<template>
	<sidebar :title="`${selectedSubRetailer?.name} User Access`" :show="showSubRetailerUserSidebar"
		@on-close="close" size="lg">
		<template v-slot:body>
			<div class="row">
				<div class="col">
					<div class="row">
						<div class="col d-flex align-items-end">
							<button class="btn bg-gradient-dark mb-0 ms-auto" :disabled="subRetailerUsersLoading"
								@click="showSubRetailerUserDetail(null)">
								<i class="fas fa-plus me-1"></i>
								Add Agent
							</button>
						</div>
					</div>
				</div>
			</div>
			<hr class="horizontal dark" />
			<div class="row">
				<div class="col">
					<div class="table-responsive p-0">
						<table class="table main-table">
							<thead>
								<tr>
									<th>Name </th>
									<th>Username </th>
									<th>Wallet Balance </th>
									<th>Date Created </th>
									<th>Availability</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-if="subRetailerUsersLoading">
									<td colspan="5">
										<div class="text-center">
											<Vue3Lottie :animationData="searchingJSON" class="height-150 py-2" />
										</div>
									</td>
								</tr>
								<tr v-if="!subRetailerUsersLoading && subRetailerUsers.length == 0">
									<td colspan="5">
										<div class="text-center">
											<Vue3Lottie :animationData="noDataJSON" class="height-150 py-2" />
											<p class="text-xs font-weight-bold">No Data Found</p>
										</div>
									</td>
								</tr>
								<tr v-for="(subRetailerUser, i) in subRetailerUsers" :key="i">
									<td> {{ subRetailerUser.name }} </td>
									<td> {{ subRetailerUser.username }}</td>
									<td>
										<div class="icon-container-action d-flex align-items-center"
											@click="showSubRetailerUserBalance(subRetailerUser)">
											<img src="/img/top-up.png" class="me-2" alt="logo" />
											{{ subRetailerUser.balance.toLocaleString('en-PH') }}
										</div>
									</td>
									<td> {{ $format.FormatFullDateTime(subRetailerUser.timestamp) }} </td>
									<td>
										<label class="switch">
											<input type="checkbox" v-model="subRetailerUser.isActive"
												@change="handleChange(subRetailerUser)" />
											<span class="slider round"></span>
										</label>
									</td>
									<td>
										<div class="icon-container-action" data-toggle="tooltip"
											data-original-title="Edit user"
											@click="showSubRetailerUserDetail(subRetailerUser)">
											<img src="/img/updatedark.png" alt="logo" />
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</template>
	</sidebar>
	<GlobalModal :show="modal.show" :type="modal.type" :title="modal.title" :message="modal.message"
		@close="modal.show = false" @confirm="handleModalConfirm" @cancel="handleModalCancel" />
</template>

<script>
import noDataJSON from "./../../../../../assets/no-data.json";
import searchingJSON from "./../../../../../assets/searching.json";
import sidebar from "../../../../../components/sidebar.vue";
import GlobalModal from "@/components/GlobalModal.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
	components: {
		sidebar,
		GlobalModal,
	},
	data() {
		return {
			noDataJSON,
			searchingJSON,
			modal: { show: false, type: 'success', title: '', message: '', confirmAction: null, cancelAction: null, context: null, }
		};
	},
	computed: {
		...mapState({
			subRetailerUsers: (state) => state.retailerController.subRetailerUsers,
			subRetailerUsersLoading: (state) =>
				state.retailerController.subRetailerUsersLoading,
			showSubRetailerUserSidebar: (state) =>
				state.retailerController.showSubRetailerUserSidebar,
			selectedSubRetailer: (state) =>
				state.retailerController.selectedSubRetailer,
		}),
	},
	methods: {
		...mapActions({
			getRetailers: "retailerController/GetRetailers",
			getSubRetailers: "retailerController/GetSubRetailers",
			updateSubRetailerBalance: "retailerController/UpdateSubRetailerBalance",
			deleteSubRetailerUser: "retailerController/DeleteSubRetailerUser",
			updateSubRetailerUserVisibility:
				"retailerController/UpdateSubRetailerUserVisibility",
		}),
		...mapMutations({
			setShowSubRetailerUserDetailSidebar:
				"retailerController/SET_ShowSubRetailerUserDetailSidebar",
			setShowSubRetailerUserSidebar:
				"retailerController/SET_ShowSubRetailerUserSidebar",
			selectSubRetailer: "retailerController/SELECT_SubRetailer",
			selectSubRetailerUser: "retailerController/SELECT_SubRetailerUser",
			showSubRetailerUserBalanceSidebar:
				"retailerController/SET_ShowSubRetailerUserBalanceSidebar",
		}),
		showSubRetailerUserDetail(subRetailerUser) {
			this.selectSubRetailerUser(subRetailerUser);
			this.setShowSubRetailerUserDetailSidebar(true);
		},
		showSubRetailerUserBalance(subRetailerUser) {
			this.selectSubRetailerUser(subRetailerUser);
			this.showSubRetailerUserBalanceSidebar(true);
		},
		close() {
			this.selectSubRetailer(null);
			this.setShowSubRetailerUserSidebar(false);
		},
		async submitSubRetailer() {
			var result = await this.updateSubRetailerBalance(this.amount).catch(
				(error) => {
					alert(error.data.ErrorMessage);
				}
			);
			if (result) {
				alert(
					`Sub Retailer #${this.selectedSubRetailer.subRetailerID} successfully loaded.`
				);
				await this.getRetailers();
				await this.getSubRetailers();
				this.close();
			}
		},
		async deleteSubRetailer(subRetailerUser) {
			this.showModal(
				'confirmation',
				'Delete User',
				`Are you sure you want to delete user ${subRetailerUser.name}?`,
				async () => {
					await this.deleteSubRetailerUser({
						subRetailerID: subRetailerUser.subRetailerID,
						subRetailerUserID: subRetailerUser.subRetailerUserID,
					}).then((response) => {
						this.showModal('success', 'Success', `User ${subRetailerUser.name} successfully deleted`);
					}).catch((err) => {
						this.showModal('error', 'Failed', err.response?.data?.ErrorMessage || 'An Error occured');
					})
				},
			);
		},
		async handleChange(subRetailerUser) {
			this.showModal(
				'confirmation',
				'Change User Visibility',
				`Are you sure you want to ${subRetailerUser.isActive ? 'activate' : 'deactivate'} this user?`,
				async () => {
					await this.updateSubRetailerUserVisibility({
						subRetailerUserID: subRetailerUser.subRetailerUserID,
						isVisible: subRetailerUser.isActive,
					}).then((response) => {
						this.showModal('success', 'Success', `User ${subRetailerUser.name} was updated!`);
					}).catch((err) => {
						this.showModal('error', 'Failed', err.response?.data?.ErrorMessage || 'Error updating visibility');
						subRetailerUser.isActive = !subRetailerUser.isActive;
					});
				},
				() => { subRetailerUser.isActive = !subRetailerUser.isActive; },
				subRetailerUser,
			);
		},
		showModal(type, title, message, confirmAction, cancelAction, context) {
			this.modal = { show: true, type, title, message, confirmAction, cancelAction, context };
		},
		async handleModalConfirm() {
			if (typeof this.modal.confirmAction === 'function') { await this.modal.confirmAction(); }
		},
		handleModalCancel() {
			if (typeof this.modal.cancelAction === 'function') { this.modal.cancelAction(); }
		},
	},
};
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
	position: relative;
	display: inline-block;
	width: 50px;
	height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

/* The slider */
.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #ccc;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

.slider:before {
	position: absolute;
	content: "";
	height: 16px;
	width: 16px;
	left: 4px;
	bottom: 4px;
	background-color: white;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

input:checked+.slider {
	background-color: #2196f3;
}

input:focus+.slider {
	box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
	-webkit-transform: translateX(26px);
	-ms-transform: translateX(26px);
	transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
	border-radius: 34px;
}

.slider.round:before {
	border-radius: 50%;
}
</style>
